import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: {
    loading: false,
    data: []
  },
  single: {
    loading: false,
    data: null,
    isEditMode: false
  },
  domain: {
    banks: [
      {
        id: 'santander',
        name: 'Santander'
      },
      {
        id: 'itau',
        name: 'Itaú'
      },
      { id: 'bradesco', name: 'Bradesco' }
    ],
    status: [
      {
        id: 'active',
        name: 'Ativo'
      },
      {
        id: 'disabled',
        name: 'Inativo'
      }
    ]
  }
};

const credenciaisSlice = createSlice({
  name: 'credenciais',
  initialState,
  reducers: {
    listarCredenciaisRequest: (state) => {
      state.list.loading = true;
      state.list.data = [];
    },
    listarCredenciaisSuccess: (state, action) => {
      state.list.loading = false;
      state.list.data = action.payload.response.data;
    },
    listarCredenciaisFailure: (state, action) => {
      state.list.loading = false;
    },
    excluirCredencialRequest: (state) => {
      state.list.loading = true;
    },
    excluirCredencialSuccess: (state, action) => {
      state.list.loading = false;
    },
    excluirCredencialFailure: (state, action) => {
      state.list.loading = false;
    },
    criarCredencialRequest: (state) => {
      state.single.loading = true;
    },
    criarCredencialSuccess: (state, action) => {
      state.single.loading = false;
    },
    criarCredencialFailure: (state, action) => {
      state.single.loading = false;
    },
    mostrarCredencialRequest: (state) => {
      state.single.loading = true;
      state.single.data = null;
    },
    mostrarCredencialSuccess: (state, action) => {
      state.single.loading = false;
      state.single.data = action.payload.response.data;
    },
    mostrarCredencialFailure: (state) => {
      state.single.loading = false;
    },
    editarCredencialRequest: (state) => {
      state.single.loading = true;
    },
    editarCredencialSuccess: (state, action) => {
      state.single.loading = false;
    },
    editarCredencialFailure: (state, action) => {
      state.single.loading = false;
    },
    ativarModoEdicao: (state) => {
      state.single.isEditMode = true;
    },
    desativarModoEdicao: (state) => {
      state.single.isEditMode = false;
    },
    limparCredencial: (state) => {
      state.single.data = null;
      state.single.loading = false;
    }
  }
});

export const {
  listarCredenciaisRequest,
  listarCredenciaisSuccess,
  listarCredenciaisFailure,
  excluirCredencialRequest,
  excluirCredencialSuccess,
  excluirCredencialFailure,
  criarCredencialRequest,
  criarCredencialSuccess,
  criarCredencialFailure,
  mostrarCredencialRequest,
  mostrarCredencialSuccess,
  mostrarCredencialFailure,
  editarCredencialRequest,
  editarCredencialSuccess,
  editarCredencialFailure,
  ativarModoEdicao,
  desativarModoEdicao,
  limparCredencial
} = credenciaisSlice.actions;

export default credenciaisSlice.reducer;
